import {contextConsistencyProtection, contextProtection, ValueType} from '../../utils';
import {useContext} from 'react';
import {FormElementContext, FormElementContextState} from './form-element-context';

export function useFormElementContext(possibleValueTypes?: ValueType, targetComponent?: any): FormElementContextState {
	const context = useContext(FormElementContext);

	contextProtection(context, targetComponent, FormElementContext);

	if (possibleValueTypes) {
		contextConsistencyProtection(context, targetComponent, possibleValueTypes);
	}

	return context;
}
